function conclusion(intro, bullets, ctaTitle, ctaText) {
  return {
    intro: intro,
    bullets: bullets,
    ctaTitle: ctaTitle || '',
    ctaText: ctaText || ''
  }
}

var HUB_ARTICLE_CONCLUSIONS = {
  'seedream-ai-image-generator-review': conclusion(
    '赶时间出方向我会先开 Seedream 5；客户要交摄影级终稿，再同一套描述去 FLUX.2 出一版对比——Miral 里两个模型同页切换，不用换工具。',
    [
      '主图别只写产品名，补台面、光线和用途，第二版往往比第一版靠谱得多。',
      'Seedream 定构图，FLUX 抠质感——这是我做电商图最常用的组合。',
      '海报上要清楚的大标题，画面用 Seedream，文字交给 GPT Image 更省心。'
    ],
    '下一步：免费试用 Seedream 5',
    '从下文挑一条提示词改产品名就行；不满意同页切 FLUX 或 Midjourney 对比。'
  ),
  'flux-ai-image-generator-review': conclusion(
    '交质感终稿我默认 FLUX.2；只是看构图和光感，Flux Schnell 更省积分——三个版本 Miral 都有，切换方便。',
    [
      '手表、3C、咖啡这类硬光场景，提示词里多写镜头和光线词。',
      'Schnell 连试几个方向 → FLUX.2 出终稿，是我最常用的套路。',
      '白底主图和 Seedream 差距不大，赶时间二选一即可。'
    ],
    '下一步：免费试用 FLUX.2',
    '先用 Schnell 试 2–3 个构图，满意再 FLUX.2 出终稿。'
  ),
  'midjourney-alternative-online': conclusion(
    '没有「完全替代 Midjourney」这一说——艺术探索继续 MJ 或 SD，商业图换 Seedream/FLUX，带字海报用 GPT Image。Miral 把这几条路线放在同一页。',
    [
      'MJ 和替代模型同一页，不用 Discord 来回切。',
      '电商主图、产品摄影、活动海报是三种活，别用一个模型硬扛。',
      '探索阶段各出一版，定稿再按场景选终稿模型。'
    ],
    '下一步：免费试用 Midjourney',
    '浏览器直接用；商业终稿可在同页切 Seedream 或 FLUX。'
  ),
  'gpt-image-generator-guide': conclusion(
    '要把标题、卖点、活动日期写进画面，GPT Image 比纯艺术模型稳；纯视觉探索仍用 Midjourney 或 Seedream，同页切换不用导出。',
    [
      '促销海报：主标题 + 副标题 + 日期 + 风格，生成后检查换行。',
      '比例写进提示词：1:1 Instagram、4:5 信息流、2:3 Pinterest、16:9 横幅图。',
      '产品底图可 Seedream/FLUX 先出，GPT Image 叠文字。'
    ],
    '下一步：免费试用 GPT Image 1.5',
    '短标题先连出 2–3 版，满意再定稿。'
  ),
  'qwen-image-generator-review': conclusion(
    '大画面营销海报、Instagram/Pinterest 封面和邮件通讯头图我会先试 Qwen；说明型条目排版换 GPT Image，两个模型同页对比很快。',
    [
      '提示词写清主标题、产品和「高分辨率、营销海报」。',
      '商业场景图跟手快可配合 Seedream；Qwen 偏高分辨率海报视觉。',
      '生成后检查标题换行，不对就再出一版。'
    ],
    '下一步：免费试用 Qwen Image 2.0 Pro',
    '从 4:5 Instagram 封面、2:3 Pinterest 图钉图或 16:9 品牌海报试起。'
  ),
  'z-image-ai-generator-review': conclusion(
    'Z Image Turbo 适合低成本试广告方向和社媒草图，终稿换 FLUX 或 Seedream 精修——全程不用离开 Miral。',
    [
      '连出 3–5 版筛构图和配色，比一次赌终稿省积分。',
      'Facebook、Instagram、TikTok 和横幅图都可先试 Turbo，定方向再换模型。',
      '和 Flux Schnell 分工：Z Image 偏广告创意，Schnell 偏摄影构图。'
    ],
    '下一步：免费试用 Z Image Turbo',
    '写促销主题、品牌色和比例，快速试方向。'
  ),
  'stable-diffusion-online-generator': conclusion(
    '插画、角色设定、二次元风探索优先 SD 3.5 在线版；商业产品图终稿同页切 Seedream 或 FLUX 就行。',
    [
      '不用本地显卡和 ComfyUI，浏览器打开就能入门。',
      '艺术探索 SD 和 Midjourney 都可，MJ 氛围感有时更强。',
      '定风格后切 Seedream/FLUX 出商业终稿。'
    ],
    '下一步：免费试用 Stable Diffusion 3.5',
    '从角色或场景提示词试 2–3 版，再决定是否切商业模型。'
  ),
  'ai-watermark-remover-online': conclusion(
    '小面积标志、角落水印、社媒截图标记都适合 AI 去水印；清理后可进 Seedream/FLUX 二次创作，商用前自查版权。',
    [
      '框选贴边、避开产品主体，复杂背景小范围多次处理。',
      '文档类素材建议先裁剪矫正，再去水印。',
      '批量整理素材逐张处理，比一次涂大面积更稳。'
    ],
    '下一步：免费试用 AI 去水印',
    '上传小图先试效果，满意再处理正式素材。'
  ),
  'handwriting-eraser-online': conclusion(
    '试卷、合同、笔记扫描件上的手写字都可以试；建议先拉正透视，再擦除——Miral 里矫正和擦除能连着做。',
    [
      '涂抹略大于笔迹，表格线附近小范围多次处理。',
      '准确时 AI 尽量保留印刷内容。',
      '完整流程：矫正 → 擦手写 →（可选）去水印 → OCR 或归档。'
    ],
    '下一步：免费试用手写擦除',
    '先小区域试效果，满意再处理整页。'
  ),
  'image-crop-dewarp-online': conclusion(
    '倾斜扫描件、弯曲书页、白板拍照都可以先拉正，再擦手写或 OCR——文档处理从这一步开始最省事。',
    [
      '弯曲严重可分两次：先大致拉正，再微调。',
      '收据、合同、证件类拍照都适用，证件请注意隐私。',
      '推荐顺序：矫正 → 手写擦除 → 去水印 → 归档。'
    ],
    '下一步：免费试用图片裁剪矫正',
    '上传一张倾斜照片即可预览效果。'
  )
}

module.exports = HUB_ARTICLE_CONCLUSIONS
